import { gql } from '@apollo/client';
import PRODUCT_VARIANT from 'api/fragments/PRODUCT_VARIANT';
const ADD_PRODUCT_VARIANT = gql `
  ${PRODUCT_VARIANT}
  mutation AddProductVariant(
    $tenantId: ID!
    $productId: ID!
    $colorName: String!
    $chainColor: String
    $tapeColor: String
    $sliderColor: String
    $previewColor: String
    $sizeName: String
    $price: Float
    $currencyId: ID
  ) {
    addProductVariant(
      tenantId: $tenantId
      productId: $productId
      colorName: $colorName
      chainColor: $chainColor
      tapeColor: $tapeColor
      sliderColor: $sliderColor
      previewColor: $previewColor
      sizeName: $sizeName
      price: $price
      currencyId: $currencyId
    ) {
      productVariant {
        ...ProductVariantFragment
        product {
          id
          dataHash
          snapshots {
            edges {
              node {
                id
                isUpToDate
              }
            }
          }
        }
      }
    }
  }
`;
export default ADD_PRODUCT_VARIANT;
